var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"network-container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"network-status"},[_c('NetworkInfo')],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-desc"},[_c('h1',[_vm._v("网络状态检测")]),_vm._v(" "),_c('p',[_vm._v("基于navigator.connection方法和资源下载速度")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53bb18cc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NetworkStatus.vue
// module id = null
// module chunks = 